var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSpectral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V16M16 12L8 12",
    stroke: "url(#paint0_linear_4744_52725)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "url(#paint1_linear_4744_52725)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4744_52725",
    x1: 14.6053,
    y1: 3.91667,
    x2: 6.74795,
    y2: 5.59789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593945,
    stopColor: "#FAAF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D97FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4744_52725",
    x1: 19.8158,
    y1: -12.25,
    x2: -3.75615,
    y2: -7.20633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593945,
    stopColor: "#FAAF40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D97FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSpectral);
export default __webpack_public_path__ + "static/media/plus-spectral.4e90c213f29c9e2852a1035bdc337449.svg";
export { ForwardRef as ReactComponent };